// extracted by mini-css-extract-plugin
export default {"wrapper":"Filters_wrapper__lU1-u","filters":"Filters_filters__ifHDH"};